import { Injector } from '@angular/core';
import { WorkOrdersService } from '../../work-orders.service';
import { ProgramDetailsGAService, ProgramDetailsBodyService } from '../../../ve.service';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { UntypedFormGroup } from '@angular/forms';

export class WorkOrderProgramGridTemplate extends DataGridTemplate {
    editForm: UntypedFormGroup;
    workOrdersService: WorkOrdersService;
    gAProgramService: ProgramDetailsGAService;
    bodyProgramService: ProgramDetailsBodyService;
    columns: any[];

    constructor(
        injector: Injector
    ) {
        super(injector);
        this.workOrdersService = injector.get(WorkOrdersService);
        this.gAProgramService = injector.get(ProgramDetailsGAService);
        this.bodyProgramService = injector.get(ProgramDetailsBodyService);
        this.editForm = this.formBuilder.group({ ProgramId: [] });
        this.setControls();
        this.setColumns();
        this.columnMenu = false;
        this.selectableSettings.enabled = true;
        this.pageable = false;
        this.gridState.take = null;
        this.filterable = 'menu';
        this.columnMenu = false;
        this.sortable = true;
        this.showSelectAll = false;
        this.height = 430;
    }

    read(opts: any): Promise<any> {
        const service = this.workOrdersService.userModule === 'VE_Body'
            ? this.bodyProgramService
            : this.gAProgramService;
        return service.read('/ProgramsForReports', true)
            .then(response => response.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode)));
    }

    create(parentEditDataItem: any): void {
        //this is kept empty on purpose
     }

    edit(dataItem: any): void { 
        //this is kept empty on purpose
    }

    delete(dataItem: any): Promise<any> { return null; }

    save(dataItem: any, isNew: boolean): Promise<any> { return null; }

    private setColumns() {
        this.columns = [
            {
                field: 'ProgramCode',
                title: 'Program',
                sortable: true,
                filterable: true,
            },
        ];
    }

    private setControls() {
        this.controls.excel = false;
        this.controls.delete = false;
        this.controls.edit = false;
        this.controls.add = false;
    }
}
